export const newId = (key?: string): string =>
  `${key ? key : ""}${Math.round(Math.random() * 10 * new Date().valueOf())}`;
